// extracted by mini-css-extract-plugin
export var editor = "Editor-module--editor--78e36";
export var slideDown = "Editor-module--slideDown--19db6";